import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export async function packageCheck(props, companyId) {
    const { tokenResponse, history } = props

    try {
      const responsePackageCheck = await axios.get(`${API_URL}/packages/check`, {
                                      headers: {
                                        "Authorization": "Bearer " + tokenResponse.accessToken,
                                        "cid": companyId
                                      },
                                    })

      const packageCheckData = responsePackageCheck.data

      console.log("packageCheckData", packageCheckData)

      if (packageCheckData.statusCode === 200) {
        return true
      }
    } catch (error) {
      const _responseCode = error.response?.data?.responseCode

      console.log("_responseCode", _responseCode)

      if (_responseCode === "PREPAID-INSUFFICIENT") {
        history.push({
          pathname: '/billings/type',
          state: {},
        });
      } else if (_responseCode === "SUBSCRIPTION-MAIN-INSUFFICIENT") {
        
        const statementResponse = await axios.get(`${API_URL}/documents/billings?status=open`, {
                                    headers: {
                                      Authorization: 'Bearer ' + tokenResponse.accessToken,
                                      'cid': companyId,
                                    },
                                  })

        const documents = statementResponse.data.data?.documents || []

        const unpaidDocuments = documents.filter(_doc => {
          if (_doc.data.billing?.disabledCancel) {
            return true
          }

          const isoTimeNow = new Date().toISOString()
          if (_doc.data.dueDate && isoTimeNow > _doc.data.dueDate) {
            return false
          }

          return true
        })

        if (unpaidDocuments.length) {
          history.push({
            pathname: '/payments',
            state: {},
          });
        } else {
          history.push({
            pathname: '/packages/add-ons',
            state: {},
          });
        }
      } else if (_responseCode === "SUBSCRIPTION-MAIN-EXPIRED") {
        const statementResponse = await axios.get(`${API_URL}/documents/billings?status=open`, {
                                    headers: {
                                      Authorization: 'Bearer ' + tokenResponse.accessToken,
                                      'cid': companyId,
                                    },
                                  })

        const documents = statementResponse.data.data?.documents || []

        const unpaidDocuments = documents.filter(_doc => {
          if (_doc.data.billing?.disabledCancel) {
            return true
          }

          const isoTimeNow = new Date().toISOString()
          if (_doc.data.dueDate && isoTimeNow > _doc.data.dueDate) {
            return false
          }

          return true
        })

        if (unpaidDocuments.length) {
          history.push({
            pathname: '/payments',
            state: {},
          });
        } else {
          history.push({
            pathname: '/packages',
            state: {},
          });
        }
      } else if (_responseCode === "SUBSCRIPTION-MAIN-NOTSTART") {
        history.push({
          pathname: '/billings/packages',
          state: {},
        });
      } else if (_responseCode === "SUBSCRIPTION-MAIN-TRIALINSUFFICIENT" || _responseCode === "SUBSCRIPTION-MAIN-TRIALEXPIRED") {
        history.push({
          pathname: '/billings/type',
          state: {},
        });
      } else {
        history.push({
          pathname: '/billings',
          state: {},
        });
      }
      
      return false
    }
}